import { UserX } from "lucide-react";
import { useAuth } from "@/features/auth/useAuth";

export function DeactivatedScreen() {
  const { logout } = useAuth();

  return (
    <div
      style={{
        display: "flex",
        minHeight: "100vh",
        background: "var(--login-bg)",
        alignItems: "center",
        justifyContent: "center",
        padding: "2rem",
        fontFamily: "'DM Sans', sans-serif",
      }}
    >
      <div
        style={{
          display: "flex",
          flexDirection: "column",
          alignItems: "center",
          gap: "1.25rem",
          maxWidth: "400px",
          textAlign: "center",
        }}
      >
        <div
          style={{
            width: "72px",
            height: "72px",
            borderRadius: "50%",
            background: "var(--login-surface)",
            border: "1.5px solid var(--login-border)",
            display: "flex",
            alignItems: "center",
            justifyContent: "center",
          }}
        >
          <UserX
            size={32}
            strokeWidth={1.5}
            style={{ color: "var(--login-error, #c44e3a)" }}
          />
        </div>

        <div>
          <h1
            style={{
              fontFamily: "'Barlow Condensed', sans-serif",
              fontWeight: 700,
              fontSize: "1.75rem",
              letterSpacing: "0.04em",
              color: "var(--login-text)",
              margin: "0 0 0.5rem 0",
            }}
          >
            Conta desativada
          </h1>
          <p
            style={{
              fontSize: "0.9375rem",
              color: "var(--login-muted)",
              lineHeight: 1.6,
              margin: 0,
            }}
          >
            Sua conta foi desativada. Fale com um administrador para reaver
            acesso.
          </p>
        </div>

        <button
          onClick={logout}
          style={{
            marginTop: "0.5rem",
            padding: "0.625rem 1.5rem",
            background: "none",
            border: "1px solid var(--login-border)",
            borderRadius: "0.5rem",
            color: "var(--login-muted)",
            fontFamily: "'DM Sans', sans-serif",
            fontSize: "0.875rem",
            cursor: "pointer",
            transition: "color 0.15s, border-color 0.15s",
          }}
          onMouseEnter={(e) => {
            (e.currentTarget as HTMLButtonElement).style.color =
              "var(--login-text)";
            (e.currentTarget as HTMLButtonElement).style.borderColor =
              "var(--login-muted)";
          }}
          onMouseLeave={(e) => {
            (e.currentTarget as HTMLButtonElement).style.color =
              "var(--login-muted)";
            (e.currentTarget as HTMLButtonElement).style.borderColor =
              "var(--login-border)";
          }}
        >
          Voltar ao login
        </button>
      </div>
    </div>
  );
}
